import _ from 'lodash';
import utils from '@/utils/utils';

// export function getQueryString(name, type) {
//     var result = '';
//     if (!type || type === 0) {
//         var loc = window.location.search.substr(1);
//         var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
//         var r = loc.match(reg);
//         if (r !== null) {
//             result = decodeURI(r[2]);
//         }
//     } else if (type === 2) {
//         let reg = new RegExp("(^|#)" + name + "=([^&]*)(&|$)", "i");
//         if (window.location.hash.indexOf("?") < 0) {
//             result = null;
//         }
//         let r = window.location.hash.split("?")[0].match(reg);
//         if (r != null) result = decodeURIComponent(r[2]);
//     } else if (type === 3){
//         let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
//         const url = window.location.hash.replace('#','');
//         let r = url.match(reg);
//         let context = "";
//         if (r != null)
//             context = decodeURIComponent(r[2]);
//         reg = null;
//         r = null;
//         return context == null || context == "" || context == "undefined" ? "" : context;
//     }
//     else {
//         var arr = location.href.split('/');
//         arr.forEach(function (item) {
//             if (item.indexOf(name) === 0) {
//                 result = item.slice(name.length + 1);
//             }
//         })
//     }
//     return result;
// };


/* 大数据上报
 * evnetType：click、show、pv等
 * eventId：上报主key，埋点的名称
 * params：其他详细参数，类型为Object，只传一层，不做递归合并
 * 目前未设置默认参数，未来看是否要设置默认参数
 */
const pvTrackLogger = (evnetType, eventId, baseParams, extendParams) => {
    if (!window.trackCustomEvent) {
        console.log('大数据脚本引入错误，无法上报');
        return;
    }
    // let pvid = getQueryString('sourceid') || getQueryString('refpage') || getQueryString('sourceid') || getQueryString('enid');
    let baseObj = {
        ...window.pvTrack,
        biz: 'ec',
        type: evnetType,
        ctime: new Date().getTime(),
        action: eventId
        // sourceid: pvid
    };
    baseParams = Object.assign({}, baseObj , baseParams);
    let data = Object.assign({}, extendParams);
    window.trackCustomEvent(
        'auto_common_event',
        { ...baseParams},
        { ...data}
    );
};

const getCookie = (name, defaultValue) => {
    var value;
    var cookie = document.cookie;
    var start = cookie.indexOf(name + '=');
    var end;
    if (start !== -1) {
        start += name.length + 1;
        end = cookie.indexOf(';', start);
        if (end === -1) {
            end = cookie.length;
        }
        value = decodeURIComponent(cookie.substring(start, end) || '');
    }
    return value || defaultValue || '';
};


const formatParams = (vals) => {
    const _vals = _.cloneDeep(vals);
    Object.keys(vals).forEach((v) => (!_vals[v] || _vals[v] === '') && delete _vals[v]);
    return _vals;
};

// 获取地址栏参数
const getUrlParam = (str) => {
    const urlStr = window.location.href;
    const start = urlStr.indexOf('?') > 0 ? urlStr.indexOf('?') : urlStr.indexOf('#');
    const paramsStr = urlStr.substr(start + 1);
    let paramsArr = paramsStr.split('&');
    paramsArr = paramsArr.map((v) => {
        if (v.includes('=')) {
            let newArr = v.split('#');
            return newArr;
        }
        return v;
    }).flat();
    const paramsArrKey = paramsArr.map((item) => {
        let num = item.indexOf('=');
        if (num > 0) {
        return item.substring(0, num);
        }
        return null;
    });
    const paramsArrVal = paramsArr.map((item) => {
        let num = item.indexOf('=');
        if (num > 0) {
        return item.substring(num + 1);
        }
        return null;
    });
    let val = '';
    paramsArrKey.forEach((v, k) => {
        if ( v === str) {
            val = paramsArrVal[k];
        }
    });
    return val;
};

// 拼接url
const linkUrl = (url, sourceid, mallTest) => {
    const _pvMoudel = utils.getUrlParam('pvareaid') ? `&pvareaid=${utils.getUrlParam('pvareaid')}` : '';
    const _adMoudel = utils.getUrlParam('adChannel') ? `&adChannel=${utils.getUrlParam('adChannel')}` : '';
    // const urlStr = window.location.href;
    const moudels = `sourceid=${sourceid}&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
    if (url.indexOf('?') < 0) {
        return `${url}?${moudels}`;
    }
    if (url.indexOf('?') > 0 && url.indexOf('=') > 0) {
        return `${url}&${moudels}`;
    }
    return `${url}?${moudels}`;
};

const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

// 判断是否是主软
const isInApp = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    const isApp =!!ua.match(/auto_android|auto_iphone/i);
    return isApp;
    // const isIos = function () {
    //     const ios = !!ua.match(/\(i[^;]+;( U;)? cpu.+mac os x/); //ios终端
    //     const iPhone = ua.indexOf('iphone') > -1 || ua.indexOf('Mac') > -1;
    //     const iPad = ua.indexOf('ipad') > -1; //是否iPad
    //     return !!(ios || iPad || iPhone);
    // };

    // function isIphoneX() {
    //     return (ua.indexOf('iphone') > -1) && (screen.height == 812 && screen.width == 375);
    // }

    // 是否ie11或edge
    // function isIE() {
    //     return (!!ua.match(/(trident)\/([\d.]+)/)) || (ua.indexOf("edge") > -1);
    // }
    // const result = {
    //     isWechat: !!ua.match(/MicroMessenger/i),
    //     isSafari: !!ua.match(/version\/([\d.]+).*safari/),
    //     isChrome: !!ua.match(/chrome\/([\d.]+)/),
    //     isApp: !!ua.match(/auto_android|auto_iphone/i),
    //     isUcweb: !!ua.match(/UCWEB|UCBrowser/i),
    //     isIos: isIos(),
    //     isIpad: ua.indexOf('ipad') > -1,
    //     isAndroid: ua.indexOf('android') > -1 || ua.indexOf('Linux') > -1,
    //     // isMobile: (function () {
    //     //     return !!/(iphone|ios|android|mini|mobile|mobi|nokia|symbian|ipod|ipad|ws\s+phone|mqqbrowser|wp7|wp8|ucbrowser7|ucweb|360\s+aphone\s+browser)/i.test(ua);
    //     // })(),
    //     isMobile: ('onorientationchange' in window),
    //     isQQ: !!ua.match(/qq\/([\d\.]+)/),
    //     // isIphoneX: isIphoneX(),
    //     isIE: isIE(),
    //     isMiniProgram: !!ua.match(/miniProgram/i) // 是否是小程序环境
    // };

    // return result;
};

// 格式化悬浮组件
const formatTcModuleArr  = (m) => {
    let _moduleDzb = {};
    let _moduleHf = {};
    let _moduleXf = {};
    m.forEach((v) => {
        const { siteUserPoster: { styleType } } = v;
        if (styleType === 3) {
            _moduleDzb = v;
        }
        if (styleType === 2) {
            _moduleHf = v;
        }
        if (styleType === 1) {
            _moduleXf = v;
        }
    });
    return { _moduleDzb, _moduleHf, _moduleXf };
};

// 悬浮组件商品获取
const getModuleTc = (moduleTc, goodsObj) => {
    let _mTc = {};
    _mTc = {
        ...moduleTc,
        siteUserPoster: {
            ...moduleTc.siteUserPoster,
            goodsObj
        }
    };
    return _mTc;
};

export default { pvTrackLogger, getCookie, formatParams, getUrlParam, linkUrl, isInApp, formatTcModuleArr, getModuleTc };